import React, { ComponentType, Dispatch, SetStateAction } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DateRangeCalendar } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { State } from './State';

type Props = {
  formState: State;
  setFormState: Dispatch<SetStateAction<State>>;
};

export const DateRangePicker: ComponentType<Props> = ({
  formState,
  setFormState,
}) => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DateRangeCalendar
      calendars={3}
      value={formState.dateRange}
      onChange={(dateRange) => setFormState({ ...formState, dateRange })}
    />
  </LocalizationProvider>
);
